/* eslint-disable-next-line no-use-before-define */
/* eslint-disable no-plusplus */
import {
  all,
  call,
  fork,
  put,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
  loggedOut,
  loginUser,
  logoutUser,
  setError,
  setUser,
  getCurrentLoginInformation,
  setCurrentLoginInformation,
  changeProfileImage,
  setProfilePicture,
  getTenantsList,
  setTenantsList,
  sendPasswordResetCode,
  passwordResetCodeSent,
  sendNewPassword,
  newPasswordSent,
  changePassword,
  passwordChanged,
  getCurrentTenantStatus,
  setCurrentTenantStatus,
  getUserLoginAttempts,
  setUserLoginAttempts,
  getOrganizationSettings,
  setOrganizationSettings,
  setIsLoading,
  getTenantDisplayInfo,
  setTenantDisplayInfo,
  getRegisterUser,
  setRegisterUser,
} from './authSlice';
import AppConsts from '../../lib/appconst';
import AccountAuthService from '../../services/Auth/AccountAuthService';
import UserLoginAttemptService from '../../services/Auth/userLoginAttemptService';
import tokenAuthService from '../../services/tokenAuthService';
import sessionService from '../../services/sessionService';
import signalRAspNetCoreHelper from '../../lib/signalRAspNetCoreHelper';

const { abp } = window;

function* handleUserLogin(input) {
  try {
    // const { user } = payload;
    const data = yield call(tokenAuthService.authenticate, input.payload);
    const tokenExpireDate = input.payload.rememberClient
      ? new Date(new Date().getTime() + 1000 * data.expireInSeconds)
      : undefined;
    abp.auth.setToken(data.accessToken, tokenExpireDate);
    abp.utils.setCookieValue(
      AppConsts.authorization.encrptedAuthTokenName,
      data.encryptedAccessToken,
      tokenExpireDate,
      abp.appPath
    );

    yield put(setUser(data.userId));
    yield put(getCurrentLoginInformation());
  } catch (e) {
    yield put(setError(e.message));
    yield put(setIsLoading(false));
  }
}

export function* watchUserLogin() {
  yield takeLatest(loginUser.type, handleUserLogin);
}

function* handleUserLogout() {
  try {
    localStorage.clear();
    sessionStorage.clear();
    abp.auth.clearToken();

    yield put(loggedOut());
    window.location = '/';
  } catch (e) {
    yield put(setError(e.message));
    yield put(setIsLoading(false));
  }
}

export function* watchUserLogout() {
  yield takeLatest(logoutUser.type, handleUserLogout);
}

function* handleUserSession() {
  try {
    const { result: data } = yield call(
      sessionService.getCurrentLoginInformations
    );

    // if (data.user && data.application.features.SignalR) {
    // if (data.application.features.SignalR.AspNetCore) {
    signalRAspNetCoreHelper.initSignalR();
    // }
    // }

    yield put(setCurrentLoginInformation(data));
  } catch (e) {
    yield put(setError(e.message));
    yield put(setIsLoading(false));
  }
}

export function* watchUserSession() {
  yield takeEvery(getCurrentLoginInformation.type, handleUserSession);
}

function* processChangeProfilePicture(input) {
  try {
    const data = yield call(sessionService.setProfileImage, input.payload);
    yield put(setProfilePicture(data.result));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchChangeProfilePicture() {
  yield takeLatest(changeProfileImage.type, processChangeProfilePicture);
}

function* getTenantsListForSelection() {
  try {
    const data = yield call(sessionService.getTenantsForSelection);
    const r = [
      {
        label: 'Host',
        tenancyName: 'default',
        value: '1',
        key: 1,
        id: 1,
      },
    ];
    for (let index = 0; index < data.length; index++) {
      r.push({
        label: data[index].name,
        tenancyName: data[index].tenancyName,
        value: data[index].id.toString(),
        key: data[index].id,
        id: data[index].id,
      });
    }
    yield put(setTenantsList(r));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetTenantsListForSelection() {
  yield takeLatest(getTenantsList.type, getTenantsListForSelection);
}

function* handleSendPasswordResetCode(input) {
  try {
    yield call(AccountAuthService.sendPasswordResetCode, input.payload);
    yield put(passwordResetCodeSent());
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchSendPasswordResetCode() {
  yield takeLatest(sendPasswordResetCode.type, handleSendPasswordResetCode);
}

function* handleResetPassword(input) {
  try {
    const data = yield call(AccountAuthService.resetPassword, input.payload);
    if (data.canLogin) {
      toast.success('Password reset successfully.');
      yield put(newPasswordSent());
    } else yield put(passwordResetCodeSent());
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchResetPassword() {
  yield takeLatest(sendNewPassword.type, handleResetPassword);
}

function* handleChangePassword(input) {
  try {
    yield call(AccountAuthService.changePassword, input.payload);
    yield put(passwordChanged());
    yield put(logoutUser());
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchChangePassword() {
  yield takeLatest(changePassword.type, handleChangePassword);
}

function* handleIsCurrentTenantAvailable(input) {
  try {
    const data = yield call(
      AccountAuthService.isCurrentTenantAvailable,
      input.payload
    );
    yield put(setCurrentTenantStatus(data));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetCurrentTenantAvailable() {
  yield takeLatest(getCurrentTenantStatus.type, handleIsCurrentTenantAvailable);
}

function* handleGetUserLoginAttempts(input) {
  try {
    const data = yield call(UserLoginAttemptService.getAll, input.payload);
    yield put(setUserLoginAttempts(data));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetUserLoginAttempts() {
  yield takeLatest(getUserLoginAttempts.type, handleGetUserLoginAttempts);
}

function* handleGetOrganizationSettings(input) {
  try {
    const data = yield call(
      sessionService.getOrganizationSettings,
      input.payload
    );
    yield put(setOrganizationSettings(data));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetOrganizationSettings() {
  yield takeLatest(getOrganizationSettings.type, handleGetOrganizationSettings);
}

function* getCurrentTenantDisplayInfo() {
  try {
    const data = yield call(sessionService.getTenantDisplayInfo);
    yield put(setTenantDisplayInfo(data));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetCurrentTenantDisplayInfo() {
  yield takeLatest(getTenantDisplayInfo.type, getCurrentTenantDisplayInfo);
}

function* handlerUserRegisteration(input) {
  try {
    const response = yield call(AccountAuthService.register, input.payload);
    const data = response.data || response;
    toast.success('Account Registered Successfully!');
    yield put(setRegisterUser(data));
  } catch (e) {
    const errorMsg = e.response?.data?.error?.message || 'Registration Failed!';
    toast.error(errorMsg);

    yield put(setRegisterUser(null));
    yield put(setIsLoading(false));
  }
}

export function* watchGetUserRegisteration() {
  yield takeLatest(getRegisterUser.type, handlerUserRegisteration);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetCurrentTenantDisplayInfo),
    fork(watchGetOrganizationSettings),
    fork(watchGetUserLoginAttempts),
    fork(watchGetCurrentTenantAvailable),
    fork(watchChangePassword),
    fork(watchResetPassword),
    fork(watchSendPasswordResetCode),
    fork(watchGetTenantsListForSelection),
    fork(watchChangeProfilePicture),
    fork(watchUserLogin),
    fork(watchUserLogout),
    fork(watchUserSession),
    fork(watchGetUserRegisteration),
  ]);
}
